import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup'; // eslint-disable-line
import { useSelector } from 'react-redux';
import swal from 'sweetalert';
import Api from '../../utils/api';
import Diversos from '../../utils/diversos';
import UsuarioForm from '../../components/Usuario/UsuarioForm';

require('moment/locale/pt-br.js'); // eslint-disable-line

const UsuarioAdd = (props) => {
  const history = useNavigate();
  const api = new Api();
  const diversos = new Diversos();
  const auth = useSelector((state) => state.auth);
  const [hasError, setHasError] = useState(false);
  const [hasSuccess, setHasSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const post = async (form, actions) => {
    if (!form.email || !form.password) {
      setHasError('Parâmetros obrigatórios inválidos');
      return false;
    }

    setHasError(null);
    setHasSuccess(null);
    setIsLoading(true);
    actions.setSubmitting(true);

    try {
      const param = {
        name: form.name,
        email: form.email,
        password: form.password,
        phone: form.phone || null,
        cpf: form.cpf || null,
        is_admin: form.is_admin || false
      };

      const { data } = await api.post(`/users`, param, auth.token);

      setHasSuccess('Registro cadastrado com sucesso.');

      await swal({
        title: 'Sucesso',
        text: `Usuário ${form.name} cadastrado com sucesso!`,
        icon: 'success',
        dangerMode: false
      });

      window.history.back();
    } catch (e) {
      if (process.env.REACT_APP_ENVIROMENT !== 'development') {
        console.error(e);
      }

      setHasError(e.message);
    } finally {
      setIsLoading(false);
      actions.setSubmitting(false);
    }

    return true;
  };

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          name: '',
          email: '',
          password: '',
          phone: '',
          cpf: '',
          is_admin: false
        }}
        validationSchema={Yup.object().shape({
          name: Yup.string().required('Nome é obrigatório'),
          email: Yup.string().email('E-mail inválido').required('E-mail é obrigatório'),
          password: Yup.string().min(6, 'Senha deve ter no mínimo 6 caracteres').required('Senha é obrigatória')
        })}
        onSubmit={post}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
          <UsuarioForm
            title="Usuário - Novo"
            subtitle="Novo Usuário"
            errors={errors}
            handleBlur={handleBlur}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            isSubmitting={isSubmitting}
            touched={touched}
            values={values}
            setFieldValue={setFieldValue}
            isLoading={isLoading}
            hasError={hasError}
            hasSuccess={hasSuccess}
          />
        )}
      </Formik>
    </>
  );
};

export default UsuarioAdd;
